const setBlackFridayContentMarginTop = () => {
  // elem next to header is content of the page, need to change its margin top to fit the promo header
  const contentElem = document.querySelector("nav")
    ?.nextElementSibling as HTMLDivElement;

  if (!contentElem) return;

  const contentElemMargin = window.getComputedStyle(contentElem).marginTop;

  if (
    contentElemMargin === "0px" &&
    !contentElem.classList.contains("gallery-ads-container") &&
    !window.location.href.includes("inbox")
  ) {
    contentElem.style.marginTop = "90px";
  }
  if (contentElemMargin === "-90px") {
    contentElem.style.marginTop = "0px";
  }

  const clearMargin = () => {
    if (window.location.href.includes("gallery")) {
      contentElem.style.marginTop = "-90px";
    } else {
      contentElem.style.marginTop = contentElemMargin;
    }
  };

  return clearMargin;
};

export default setBlackFridayContentMarginTop;
